import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import {HTTP_INTERCEPTORS} from '@angular/common/http';

import { AppComponent } from './app.component';
import { SceneComponent } from './scene/scene.component';
import { ShelfElementsComponent } from './shelf-elements/shelf-elements.component';
import {DataService} from './data.service';
import { ShelfElementService } from './shelf-element.service';
import { ElementListComponent } from './element-list/element-list.component';

import {KklRestService} from './kkl-rest-service.service';
import { CustomerFormComponent } from './customer-form/customer-form.component';

import { AzureAuthorizationInterceptor } from './interceptor.service';



@NgModule({
  declarations: [
    AppComponent,
    SceneComponent,
    ShelfElementsComponent,
    ElementListComponent,
    CustomerFormComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
  ],
  providers: [
      DataService,
      ShelfElementService,
      KklRestService,
      {
          provide: HTTP_INTERCEPTORS,
          useClass: AzureAuthorizationInterceptor,
          multi: true,
      }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts